import React from 'react';

import { bool, func, node, oneOf, oneOfType, string } from 'prop-types';

import View from './styles';

const FlagIcon = ({
  size,
  suffix,
  status,
  isLink,
  action,
  iconComponent,
  disabled,
  backgroundColor,
  color,
  iconDirection,
  border
}) => {
  const formatedLabel = `${ status } ${ suffix ? `(${ suffix })` : '' }`;
  
  return (
    <View
      size={ size }
      status={ status }
      isLink={ isLink }
      onClick={ () => isLink && action() }
      disabled={ disabled }
      backgroundColor={ backgroundColor }
      color={ color }
      iconDirection={ iconDirection }
      border={border}
    >
      { formatedLabel }
      { iconComponent }
    </View>
  );
};

FlagIcon.propTypes = {
  size: oneOf([ 'sm', 'md' ]),
  suffix: oneOfType([ bool, string ]),
  status: string.isRequired,
  isLink: bool,
  action: func,
  disabled: bool
};

FlagIcon.defaultProps = {
  size: 'md',
  suffix: false,
  isLink: false,
  action: () => {},
  disabled: false
};

export default FlagIcon;
